import theme from "@/theme";

export const style = {
  modalWrapper: {
    position: "fixed",
    overflowY: "auto",
    width: "100%",
    height: "100vh",
    padding: "40px 0",
    dysplay: "flex",
    boxSizing: "border-box",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  modal: {
    margin: "auto",
    maxWidth: "49.75rem",
    width: "100%",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    borderRadius: "1rem",
    padding: "1.25rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  modalInfoOpen: {
    left: "50%",
    position: "fixed",
    bottom: "20px",
    padding: "1rem",
    zIndex: 3000,
    transform: "translateX(-50%)",
    backgroundColor: "#fff",
    borderRadius: "1.375rem",
    width: "51rem",
    boxShadow: " 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    border: " 1px solid #e4e7e9",
  },
  modalInfoClose: {
    right: 0,
    position: "fixed",
    bottom: "0rem",
    padding: "1rem",
    zIndex: 3000,
    backgroundColor: "transparent",
    borderRadius: "1.375rem",
    width: "100%",
    maxWidth: "50.5625rem",
  },
  modalCloseButton: {
    padding: 0,
    minWidth: 0,
    position: "absolute",
    right: "20px",
    top: "20px",
    height: "1.625rem",
    width: "1.625rem",
    borderRadius: "50%",
    bgcolor: "none",
    cursor: "pointer",
    "&:hover": {
      bgcolor: "none",
      boxShadow: "none",
    },
    "&:active": {
      bgcolor: "none",
      boxShadow: "none",
    },
    "&.Mui-focusVisible": {
      bgcolor: "none",
      boxShadow: "none",
    },
  },
  modalContent: {
    // maxHeight: "calc(100vh - 300px)",
    border: `1px solid ${theme.palette.custom.blueGray100}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "1rem",
    padding: "1.375rem",
    minHeight: "13.1875rem",
    marginBottom: "1rem",
    // overflowY: "auto",
  },
  removeImageButton: {
    padding: 0,
    minWidth: 0,
    position: "absolute",
    right: "0.875rem",
    top: "0.875rem",
    height: "2rem",
    width: "2rem",
    borderRadius: "50%",
    bgcolor: theme.palette.custom.blueGray100,
    cursor: "pointer",
  },

  chipStyle: (selectedChip: string, chipValue: string) => ({
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "14px",
    textAlign: "right",
    height: "34px",
    borderRadius: "16px",
    border: `1px solid ${theme.palette.custom.mainBlue}`,
    bgcolor: selectedChip.includes(chipValue)
      ? theme.palette.custom.mainBlue
      : theme.palette.custom.mainWhite,
    color: selectedChip.includes(chipValue)
      ? theme.palette.custom.mainWhite
      : theme.palette.custom.mainBlue,
    "&:hover": {
      bgcolor: theme.palette.custom.mainBlue,
      color: theme.palette.custom.mainWhite,
    },
  }),

  sliderInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 64,
    gap: "6px",
  },

  sliderMiddleSide: {
    width: "100px",
    height: 4,

    "& .MuiSlider-thumb": {
      width: 12,
      height: 12,
      backgroundColor: "#FFFFFF",
      border: "1px solid #0000001A",
      boxShadow: "0px 2px 4px 0px #0000001A",
    },

    "& .MuiSlider-track": {
      backgroundColor: "transparent !important",
      border: "none",
    },

    "& .MuiSlider-rail": {
      backgroundColor: "#C6CACE",
      opacity: 1,
    },

    "& .MuiSlider-valueLabel": {
      width: "26px",
      height: "20px",
      backgroundColor: "#2a2d31",
      borderRadius: "6px",
      color: "#fff",
      fontSize: "12px",
      fontWeight: 500,
    },
  },

  charCounter: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0%",
    textAlign: "right",
    height: "24px",
  },

  hideButton: {
    position: "relative",
    fontFamily: "Inter",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: "18px",
    lineHeight: "155%",
    letterSpacing: "0%",
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    padding: 0,
    minWidth: 0,
    textDecoration: "none",

    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 3,
      width: "100%",
      height: "1px",
      backgroundColor: theme.palette.custom.mainBlue,
    },
  },

  howToPublishWrapper: {
    position: "absolute",
    bottom: "40px",
    right: "38px",
    width: "172px",
    height: "40px",
    borderRadius: "26px",
    padding: "8px",
    gap: "4px",
    display: "flex",
    justifyContent: "flex-end",
  },

  howToPublishButton: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "100%",
    textTransform: "none",
    color: theme.palette.custom.mainBlue,
    padding: 0,
    minWidth: 0,
  },
};
